import "spotlight.js";

const LIGHTBOX_SOURCES = {};

document.querySelectorAll("[data-lightbox-src]").forEach((element, i) => {
    const src = element.getAttribute("data-lightbox-src");
    const description = element.getAttribute("data-lightbox-description");
    const group = element.getAttribute("data-lightbox-group") ? element.getAttribute("data-lightbox-group") : 'global';
    const index = element.getAttribute('data-lightbox-index') ? parseInt(element.getAttribute('data-lightbox-index')) : 1;

    if(!LIGHTBOX_SOURCES[group]){
        LIGHTBOX_SOURCES[group] = [];
    }

    if (src) {
        const image = {
            src: src
        }

        if(description){
            image.description = description
        }

        LIGHTBOX_SOURCES[group].push(image);
    }

    element.addEventListener("click", () => {
        if (LIGHTBOX_SOURCES[group].length > 0) {
            console.log(index);
            Spotlight.show(LIGHTBOX_SOURCES[group], {
                index: index,
                theme: "white",
                animation: "fade",
                infinite: LIGHTBOX_SOURCES[group].length > 1,
            });
        }
    });
});